import PerfectScrollbar from 'perfect-scrollbar';
import { isMobile } from '@H/device_helpers';

function _updateScrollbar(e, ps) {
    if (isMobile()) {
        _destroyScrollbar(ps);
    } else {
        ps.update();
    }
}

function _destroyScrollbar(ps) {
    ps.destroy();
}

export default function initScrollbar() {
    if (!isMobile()) {
        const checkEl = document.querySelector('.perfect-scrollbar');
        if (checkEl) {
            const ps = new PerfectScrollbar('.perfect-scrollbar', {
                wheelSpeed: 2,
                wheelPropagation: true,
                minScrollbarLength: 20,
                suppressScrollX: true
            });

            window.addEventListener('resize', e => _updateScrollbar(e, ps));
            window.addEventListener('orientationchange', e =>
                _updateScrollbar(e, ps)
            );
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/addScrollbar.js